<h2 mat-dialog-title> {{data.title | translatei18n}}</h2>
<mat-dialog-content *ngIf="data.content != 'MORText' else MORText">
  <p>{{data.content | translatei18n}}</p>
</mat-dialog-content>

<ng-template #MORText>
  <mat-dialog-content>
    <p class="font-black">{{'MORText1' | translatei18n}}</p>
    <p class="font-black">{{'MORText2' | translatei18n}}</p>
    <p class="font-black">{{'MORText3' | translatei18n}}</p>
    <p class="font-black">{{'MORText4' | translatei18n}}</p>
    <p class="font-black">{{'MORText5' | translatei18n}}</p>
    <p class="font-black">{{'MORText6' | translatei18n}}</p>
    <p class="font-black">{{'MORText7' | translatei18n}}</p>
  </mat-dialog-content>
</ng-template>

<mat-dialog-actions class="flex flex-row justify-center gap-2">
  <button *ngIf="data.cancel" mat-button (click)="cancel()">{{cancelButton | translatei18n}}</button>
  <button mat-button (click)="accept()" cdkFocusInitial>{{acceptButton | translatei18n}}</button>
</mat-dialog-actions>